/* Lily Arkwright - upgrade purchase routing, 2026-10-01.
 * Prices come from Shopify variants, never from the displayed total or properties.
 * Theme protection is not a substitute for server-side checkout validation.
 */
(function () {
  'use strict';
  if (window.LAUpgradePurchase) return;
  var states = new WeakMap(), activeAdds = 0, checking = false, cartUpdating = false;
  var types = ['clarity', 'twoTone', 'pointedProngs', 'bandWidth', 'engraving'];
  var owned = ['Diamond Clarity', 'Two Tone', 'Pointed Prongs', 'Band Width', 'Engraving', 'Engraving Style'];
  var version = '2026-10-01.2';
  function text(v) { return String(v == null ? '' : v).trim(); }
  function rootUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (window.routes && window.routes.rootUrl) || '/';
    return r.replace(/\/?$/, '/');
  }
  function cartUrl() { return (window.routes && window.routes.cartUrl) || rootUrl() + 'cart'; }
  function parse(el) { if (!el) throw new Error('Ring options have not loaded. Please refresh this page.'); return JSON.parse(el.textContent); }
  function error(form, message) {
    var el = form.querySelector('[data-la-personalise] [data-la-error]') || form.querySelector('[data-la-routing-error]');
    if (!el) { el = document.createElement('p'); el.dataset.laRoutingError = ''; el.className = 'ProductForm__Error Alert Alert--error'; form.appendChild(el); }
    el.setAttribute('role', 'alert');
    el.textContent = message; el.hidden = false;
  }
  function props(value) { return Array.isArray(value) ? Object.fromEntries(value) : value || {}; }
  function clearError(form) { form.querySelectorAll('[data-la-routing-error], [data-la-personalise] [data-la-error]').forEach(function (el) { el.hidden = true; el.textContent = ''; }); }
  function mark(form, busy) {
    form.setAttribute('aria-busy', String(busy));
    form.querySelectorAll('.ProductForm__AddToCart, .Cart__Checkout').forEach(function (el) {
      if (busy) { if (!el.hasAttribute('data-la-was-disabled')) el.dataset.laWasDisabled = String(el.disabled); el.disabled = true; }
      else if (el.hasAttribute('data-la-was-disabled')) { el.disabled = el.dataset.laWasDisabled === 'true'; delete el.dataset.laWasDisabled; }
    });
  }
  function assertPrice(v, paid) {
    if (!v || !Number.isSafeInteger(Number(v.id)) || Number(v.id) <= 0 || !Number.isSafeInteger(Number(v.price)) || Number(v.price) < (paid ? 1 : 0)) {
      throw new Error('An upgrade price could not be verified. Please refresh the page or contact us.');
    }
    return v;
  }
  function carat(value) { var m = text(value).replace(',', '.').match(/\d+(?:\.\d+)?/); return m ? Number(m[0]) : null; }
  function ringCarat(data, rv) {
    var i = data.ring.options.findIndex(function (n) { return /centre stone|center stone|carat weight|carat/i.test(n); });
    return carat(rv.options[i < 0 ? 0 : i]);
  }
  function resolve(data, rv, selection, allowUnavailable) {
    var out = [];
    function variants(type) {
      var d = data[type];
      if (!d || !Array.isArray(d.variants)) throw new Error('The selected upgrade is not configured for this ring.');
      return d.variants.filter(function (v) { return allowUnavailable || v.available === true; });
    }
    function add(type, value, matches) {
      if (matches.length !== 1) throw new Error('Your ' + type.replace(/([A-Z])/g, ' $1').toLowerCase() + ' selection is unavailable. Please select it again.');
      var v = assertPrice(matches[0], true);
      out.push({type: type, value: value, id: Number(v.id), price: Number(v.price)});
    }
    if (data.clarity) {
      var grade = text(selection.clarity).toUpperCase();
      if (!grade) throw new Error('Please confirm your diamond clarity.');
      var weight = ringCarat(data, rv);
      if (grade !== 'VS1') add('clarity', grade, variants('clarity').filter(function (v) { return text(v.clarity).toUpperCase() === grade && weight !== null && carat(v.carat) === weight; }));
      else if (!allowUnavailable && !variants('clarity').some(function (v) { return text(v.clarity).toUpperCase() === 'VS1' && weight !== null && carat(v.carat) === weight; })) throw new Error('The standard clarity option could not be verified. Please refresh the page.');
    }
    ['twoTone', 'pointedProngs'].forEach(function (type) {
      var wanted = text(selection[type]);
      if (!wanted || wanted === 'standard') return;
      var expected = type === 'twoTone' ? 'two_tone' : 'pointed';
      if (wanted !== expected) throw new Error('An upgrade selection is invalid.');
      add(type, wanted, variants(type).slice(0, 1));
    });
    if (text(selection.bandWidth) && selection.bandWidth !== 'standard') add('bandWidth', selection.bandWidth, variants('bandWidth').filter(function (v) { return text(v.value) === text(selection.bandWidth); }));
    if (text(selection.engravingText)) {
      if (selection.engravingText.length > 15) throw new Error('Engraving must be no more than 15 characters.');
      var engravingStyle = text(selection.engravingStyle).toLowerCase();
      if (engravingStyle !== 'script' && engravingStyle !== 'classic') throw new Error('An upgrade selection is invalid.');
      var engravingVariants = variants('engraving');
      var engravingMatches = engravingVariants.filter(function (v) { return text(v.style).toLowerCase() === engravingStyle; });
      if (!engravingMatches.length && data.engraving.variants.length === 1 && text(data.engraving.variants[0].style).toLowerCase() === 'default title') engravingMatches = engravingVariants;
      add('engraving', text(selection.engravingText), engravingMatches);
    }
    return out;
  }
  function snapshot(form) {
    var cfg = parse(form.querySelector('[data-la-purchase-config]'));
    var box = form.querySelector('[data-la-personalise]');
    if (!box || box.dataset.laInit !== '1') throw new Error('Ring options have not finished loading. Please refresh this page.');
    var data = parse(box.querySelector('[data-la-data]'));
    cfg.types.forEach(function (t) { if (!data[t] || !Array.isArray(data[t].variants)) throw new Error('Some ring upgrades have not loaded. Please refresh this page.'); });
    var input = form.querySelector('select[name="id"], input[name="id"]');
    var rv = input && data.ring.variants.find(function (v) { return String(v.id) === input.value; });
    if (!rv || rv.available !== true) throw new Error('Please select an available centre stone and metal.');
    assertPrice(rv, false);
    var selection = {};
    cfg.types.filter(function (t) { return t !== 'engraving'; }).forEach(function (t) {
      var row = box.querySelector('[data-la-row="' + t + '"]');
      var picked = row && row.querySelectorAll('[data-la-options] .la-choice.is-selected');
      if (!row || row.hidden || !picked || picked.length !== 1) throw new Error('Please confirm all ring options before adding to your basket.');
      var label = text(picked[0].textContent);
      if (t === 'twoTone') selection[t] = label === 'Standard' ? 'standard' : label === 'Two Tone' ? 'two_tone' : 'invalid';
      else if (t === 'pointedProngs') selection[t] = label === 'Standard' ? 'standard' : label === 'Pointed' ? 'pointed' : 'invalid';
      else selection[t] = label === 'Standard' ? 'standard' : label;
    });
    if (cfg.types.indexOf('engraving') !== -1) {
      var engr = box.querySelector('[data-la-engraving-text]'), style = box.querySelector('[data-la-engraving-style]');
      if (!engr || !style) throw new Error('Engraving options have not loaded. Please refresh this page.');
      selection.engravingText = text(engr.value); selection.engravingStyle = style.value;
    }
    var properties = {};
    new FormData(form).forEach(function (value, name) {
      var m = name.match(/^properties\[(.+)\]$/);
      if (m && typeof value === 'string' && text(value) && owned.indexOf(m[1]) === -1 && m[1].indexOf('_la_config_') !== 0) properties[m[1]] = value;
    });
    if (cfg.sizes.length) {
      var sizeLabel = form.querySelector('.ProductForm__SelectedValue[data-attr="Ring Size: "]');
      var size = sizeLabel ? text(sizeLabel.textContent).replace(/^Ring Size:\s*/i, '') : '';
      if (cfg.sizes.indexOf(size) === -1) throw new Error('Please select a ring size.');
      properties['Ring Size'] = size;
    }
    if (data.clarity) properties['Diamond Clarity'] = text(selection.clarity).toUpperCase();
    if (selection.twoTone === 'two_tone') properties['Two Tone'] = 'Yes';
    if (selection.pointedProngs === 'pointed') properties['Pointed Prongs'] = 'Yes';
    if (selection.bandWidth && selection.bandWidth !== 'standard') properties['Band Width'] = selection.bandWidth;
    if (selection.engravingText) { properties.Engraving = selection.engravingText; properties['Engraving Style'] = selection.engravingStyle; }
    var q = form.querySelector('[name="quantity"]'), quantity = q ? Number(q.value) : 1;
    if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Please select a valid quantity.');
    var plan = form.querySelector('[name="selling_plan"]');
    if (plan && plan.value) throw new Error('This purchase option requires assistance. Please contact us.');
    return {cfg: cfg, variant: rv, quantity: quantity, properties: properties, upgrades: resolve(data, rv, selection, false)};
  }
  async function json(url, options) {
    var control = new AbortController(), timer = setTimeout(function () { control.abort(); }, 20000);
    try {
      var response = await fetch(url, Object.assign({credentials: 'same-origin', cache: 'no-store'}, options || {}, {signal: control.signal}));
      var result = await response.json();
      if (!response.ok) { var failure = new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : 'Your basket could not be updated.'); failure.httpStatus = response.status; throw failure; }
      return result;
    } finally { clearTimeout(timer); }
  }
  function post(path, payload) { return json(rootUrl() + path, {method: 'POST', headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify(payload)}); }
  function matches(cart, config, token) {
    if (!cart || !Array.isArray(cart.items)) return false;
    var group = cart.items.filter(function (i) { return i.properties && i.properties._la_config_id === token; });
    if (group.length !== config.upgrades.length + 1) return false;
    var parent = group.find(function (i) { return i.properties._la_config_role === 'ring' && String(i.variant_id || i.id) === String(config.variant.id); });
    if (!parent || parent.quantity !== config.quantity || Number(parent.original_price) !== Number(config.variant.price)) return false;
    if (!Object.keys(config.properties).every(function (k) { return text(parent.properties[k]) === text(config.properties[k]); })) return false;
    return config.upgrades.every(function (u) {
      var found = group.filter(function (i) { return String(i.variant_id || i.id) === String(u.id) && i.properties._la_upgrade_type === u.type && text(i.properties._la_upgrade_value) === text(u.value); });
      return found.length === 1 && found[0].quantity === config.quantity && Number(found[0].original_price) === u.price && found[0].parent_relationship && found[0].parent_relationship.parent_key === parent.key;
    });
  }
  async function rollback(token) {
    var cart = await json(rootUrl() + 'cart.js'), updates = {};
    cart.items.forEach(function (i) { if (i.properties && i.properties._la_config_id === token) updates[i.key] = 0; });
    if (Object.keys(updates).length) await post('cart/update.js', {updates: updates});
    cart = await json(rootUrl() + 'cart.js');
    return !cart.items.some(function (i) { return i.properties && i.properties._la_config_id === token; });
  }
  function success(form, config, cart) {
    var section = form.closest('[data-section-settings]'), settings = section ? JSON.parse(section.dataset.sectionSettings) : {};
    if (!settings.useAjaxCart || !document.getElementById('sidebar-cart')) { window.location.assign(cartUrl()); return; }
    form.dispatchEvent(new CustomEvent('product:added', {bubbles: true, detail: {variant: config.variant, quantity: config.quantity * (1 + config.upgrades.length), cart: cart, source: 'la-upgrade-purchase'}}));
  }
  async function add(form) {
    if (checking) { error(form, 'Please wait while your basket is being checked.'); return; }
    var state = states.get(form) || {busy: false, uncertain: false, until: 0}; states.set(form, state);
    if (state.busy || Date.now() < state.until) return;
    if (state.uncertain) { error(form, 'Your last basket update could not be confirmed. Review your basket and refresh this page before trying again.'); return; }
    clearError(form);
    var cfg;
    try { cfg = parse(form.querySelector('[data-la-purchase-config]')); } catch (e) { error(form, e.message); return; }
    if (form.closest('[data-section-type="featured-product"]')) {
      var url = new URL(cfg.url, location.origin), vi = form.querySelector('[name="id"]');
      if (vi && vi.value) url.searchParams.set('variant', vi.value);
      window.location.assign(url.href); return;
    }
    var config;
    try { config = snapshot(form); } catch (e) {
      error(form, e.message);
      if (/ring size/i.test(String(e.message || ''))) {
        var sizeLabel = form.querySelector('.ProductForm__SelectedValue[data-attr="Ring Size: "]');
        var sizeButton = sizeLabel && sizeLabel.closest('button');
        if (sizeButton && sizeButton.focus) sizeButton.focus();
      }
      return;
    }
    var token = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    var ringProps = Object.assign({}, config.properties, {_la_config_id: token, _la_config_role: 'ring', _la_config_version: version});
    var items = [{id: Number(config.variant.id), quantity: config.quantity, properties: ringProps}];
    config.upgrades.forEach(function (u) {
      var p = {_la_config_id: token, _la_config_role: 'upgrade', _la_config_version: version, _la_upgrade_type: u.type, _la_upgrade_value: u.value};
      if (u.type === 'engraving') { p['Engraving Text'] = config.properties.Engraving; p['Engraving Style'] = config.properties['Engraving Style']; }
      items.push({id: u.id, quantity: config.quantity, parent_id: Number(config.variant.id), properties: p});
    });
    state.busy = true; activeAdds++; mark(form, true);
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    var cart, confirmed = false, addReturned = false;
    try {
      await post('cart/add.js', {items: items});
      addReturned = true;
      cart = await json(rootUrl() + 'cart.js');
      if (!matches(cart, config, token)) throw new Error('The ring and all selected upgrade charges could not be verified.');
      confirmed = true;
    } catch (e) {
      // A lost response does not mean the server rejected the request. Never retry the add automatically.
      try { cart = await json(rootUrl() + 'cart.js'); confirmed = matches(cart, config, token); } catch (ignored) {}
      if (!confirmed) {
        var removed = false;
        try { removed = await rollback(token); } catch (ignored) {}
        state.uncertain = !removed || (!addReturned && !e.httpStatus);
        error(form, !state.uncertain ? 'Your configuration was not added in full and has been removed. Please review your options and try again. ' + e.message : 'We could not confirm the complete ring configuration. Review your basket and refresh this page before trying again.');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      }
    } finally {
      activeAdds--; state.busy = false; state.until = Date.now() + 650; mark(form, false);
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
    if (confirmed) success(form, config, cart);
  }
  function cartSelection(item) {
    var p = item.properties || {}, s = {};
    if (item.catalogue.clarity) s.clarity = text(p['Diamond Clarity']) || 'VS1';
    if (item.catalogue.twoTone) s.twoTone = /^yes$/i.test(text(p['Two Tone'])) ? 'two_tone' : 'standard';
    if (item.catalogue.pointedProngs) s.pointedProngs = /^yes$/i.test(text(p['Pointed Prongs'])) ? 'pointed' : 'standard';
    if (item.catalogue.bandWidth) s.bandWidth = text(p['Band Width']) || 'standard';
    if (item.catalogue.engraving) { s.engravingText = text(p.Engraving); s.engravingStyle = text(p['Engraving Style']); }
    return s;
  }
  function validateCart(cart) {
    if (!cart || cart.guard_version !== version || !Array.isArray(cart.items)) throw new Error('Basket verification is unavailable. Please refresh the page and try again.');
    cart.items.forEach(function (item) { item.properties = props(item.properties); });
    cart.items.forEach(function (item) {
      var p = item.properties;
      if (p._la_config_role === 'upgrade' || p._la_upgrade_type) {
        var parent = cart.items.find(function (i) { return i.key === item.parent_key; });
        if (!parent || (p._la_config_id && (!parent.properties || parent.properties._la_config_id !== p._la_config_id))) throw new Error('An upgrade is missing its matching ring. Remove the unmatched upgrade from your basket.');
        return;
      }
      var data = item.catalogue;
      if (!data) return;
      var rv = data.ring.variants[0], upgrades = resolve(data, rv, cartSelection(item), true);
      var children = cart.items.filter(function (i) { return i.parent_key === item.key && i.properties && i.properties._la_upgrade_type; });
      if (p._la_config_id && cart.items.some(function (i) { return i.key !== item.key && i.properties && i.properties._la_config_id === p._la_config_id && i.parent_key !== item.key; })) throw new Error('A ring upgrade is linked incorrectly. Remove this configuration and add it again.');
      if (children.length !== upgrades.length || !upgrades.every(function (u) {
        var found = children.filter(function (i) { return String(i.variant_id) === String(u.id) && i.properties._la_upgrade_type === u.type && text(i.properties._la_upgrade_value) === text(u.value); });
        return found.length === 1 && found[0].quantity === item.quantity && Number(found[0].original_price) === u.price;
      })) throw new Error('The upgrade charges do not match your ring specification. Remove the ring and its upgrades, then add your chosen configuration again.');
    });
    return true;
  }
  async function checkout(form, button) {
    if (checking) return;
    if (activeAdds || cartUpdating) { error(form, 'Please wait while your basket is updated. If this continues, refresh your basket.'); return; }
    checking = true; clearError(form); mark(form, true);
    try {
      var cart = await json(cartUrl() + '?view=la-upgrade-validation&timestamp=' + Date.now());
      validateCart(cart);
      var rendered = parse(form.querySelector('[data-la-cart-keys]'));
      form.querySelectorAll('[name="updates[]"]').forEach(function (input) {
        var key = rendered[Number(input.dataset.line) - 1];
        var item = cart.items.find(function (i) { return i.key === key; });
        if (!item || Number(input.value) !== item.quantity) throw new Error('Your basket has changed or is still updating. Refresh your basket before checking out.');
      });
      // Post only checkout and the note. Do not reapply stale hidden quantity inputs.
      var submit = document.createElement('form'); submit.method = 'POST'; submit.action = cartUrl(); submit.hidden = true;
      var go = document.createElement('input'); go.type = 'hidden'; go.name = 'checkout'; go.value = 'Checkout'; submit.appendChild(go);
      var note = form.querySelector('[name="note"]');
      if (note) { var n = document.createElement('input'); n.type = 'hidden'; n.name = 'note'; n.value = note.value; submit.appendChild(n); }
      document.body.appendChild(submit); HTMLFormElement.prototype.submit.call(submit);
    } catch (e) { error(form, e.message); }
    finally { checking = false; mark(form, false); }
  }
  function bind(scope) {
    scope.querySelectorAll('[data-la-purchase-config]').forEach(function (m) {
      var form = m.closest('form'); if (!form || form.dataset.laSubmitBound) return;
      form.dataset.laSubmitBound = '1'; form.submit = function () { add(form); };
    });
    scope.querySelectorAll('[data-la-cart-keys]').forEach(function (m) {
      var form = m.closest('form'); if (!form || form.dataset.laCheckoutBound) return;
      form.dataset.laCheckoutBound = '1'; form.submit = function () { checkout(form); };
    });
  }
  function watchCartChange(e) {
    var target = e.target && e.target.nodeType === 1 ? e.target : null;
    if (!target) return;
    var control = target.closest('[data-action="update-item-quantity"], [data-action="remove-item"], [name="updates[]"]');
    var form = control && control.closest('form');
    if (!form || !form.querySelector('[data-la-cart-keys]')) return;
    if (e.type === 'click' && control.tagName === 'INPUT') return;
    if (checking) { e.preventDefault(); e.stopImmediatePropagation(); error(form, 'Please wait while your basket is being checked.'); return; }
    cartUpdating = true;
  }
  window.addEventListener('click', watchCartChange, true);
  window.addEventListener('change', watchCartChange, true);
  window.LAUpgradePurchase = {version: version, add: add, checkout: checkout, bind: bind, validateCart: validateCart};
  bind(document);
  var observer = new MutationObserver(function (records) {
    if (records.some(function (r) { return Array.from(r.addedNodes).some(function (n) { return n.nodeType === 1 && (n.matches('[data-la-cart-keys]') || n.querySelector('[data-la-cart-keys]')); }); })) cartUpdating = false;
    if (records.some(function (r) { return Array.from(r.addedNodes).some(function (n) { return n.nodeType === 1 && (n.matches('[data-la-purchase-config],[data-la-cart-keys]') || n.querySelector('[data-la-purchase-config],[data-la-cart-keys]')); }); })) bind(document);
  });
  observer.observe(document.documentElement, {childList: true, subtree: true});
})();